module.exports = __webpack_public_path__ + "media/luxury-2026/pool-house-aerial-01e40271.jpg";